interface SvgInterface {
    className?: string;
    onClick?: () => void;
}
export function PlusIcon({className = '', onClick = () => {}}: SvgInterface) {
    return <svg className={className} enableBackground="new 0 0 48 48" id="Layer_1" version="1.1" viewBox="0 0 48 48" width="48px" xmlns="http://www.w3.org/2000/svg"><g id="Layer_3"><path d="M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M35,26h-9v8.998h-4V26h-9v-4   h9v-8.998h4V22h9V26z"/></g></svg>;
}